import React from "react";
import { companyLabel, signatureCompanyLabel, remainingPercentage, thaiDate, validPercentage } from "../utils/handover";
import "./handover.css";

export default function HandoverPreview({ document, values, clients, quotationClientId }) {
  const label = (id, snapshot) => companyLabel(id, snapshot, clients);
  const quotationClient = quotationClientId || values.deliveredToClientId;
  const remaining = String(document.completionPercentage) === values.completionPercentage
    ? document.remainingPercentage : remainingPercentage(values.completionPercentage);
  const signature = (person, snapshot, role, key, isRecipient = false) => (
    <div className="handover-signature" key={key}>
      <div>ลงชื่อ ................................................</div>
      <div>({person.name || "ชื่อผู้ลงนาม"})</div>
      {(!isRecipient || person.position) && <div>{person.position || "ตำแหน่ง\u00a0"}</div>}
      {(!isRecipient || person.clientId) && <div>{signatureCompanyLabel(person.clientId, snapshot?.company, clients)}</div>}
      <div className="handover-signature-role">{role}</div>
    </div>
  );
  return (
    <aside className="min-w-0" aria-label="ตัวอย่างเอกสาร">
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">ตัวอย่างเอกสาร · A4 แนวตั้ง</p>
      <article className="handover-paper" lang="th">
        <h3>หนังสือส่งมอบงาน</h3>
        <p className="handover-date">วันที่ {thaiDate(values.documentDate)}</p>
        <p className="handover-body">
          ตามที่ข้าพเจ้า {document.issuerCompany?.name} ได้รับการว่าจ้างจาก {label(quotationClient, document.deliveredToClient)} ให้ทำการดำเนินงานแคมเปญ  {document.projectName} ประเภทงาน {document.workType} ตามเอกสารใบสั่งซื้อเลขที่ {document.quotationNumber} นั้น{" "}
          {validPercentage(values.completionPercentage) && Number(values.completionPercentage) === 100
            ? "บัดนี้ได้ดำเนินงานดังกล่าวเสร็จสิ้นแล้ว 100%"
            : `บัดนี้ได้ดำเนินงานเสร็จสิ้นแล้ว ${validPercentage(values.completionPercentage) ? Number(values.completionPercentage) : "…"}% อีก ${remaining ?? "…"}% จะเสร็จสิ้นในเดือน${thaiDate(values.expectedCompletionMonth, true)}`}
          {" "}โดยได้ส่งมอบเอกสารและสิ่งอื่นๆ ที่เกี่ยวข้องกับการดำเนินงาน (ถ้ามี) ให้กับ {label(values.deliveredToClientId, document.deliveredToClient)} เรียบร้อยแล้ว
        </p>
        <p className="handover-body">จึงเรียนมาเพื่อโปรดพิจารณาอนุมัติ</p>
        <div className="handover-bottom">
          <div className="handover-remark">{values.remarkEnabled && <><strong>หมายเหตุ</strong><p>{values.remark}</p></>}</div>
          <div>
            {signature(values.sender, document.sender, "ผู้ส่งมอบงาน", "sender")}
            {values.recipients.slice(0, values.additionalRecipientEnabled ? 2 : 1).map((person, index) => signature(person, document.recipients?.[index], "ผู้รับมอบงาน", index, true))}
          </div>
        </div>
      </article>
    </aside>
  );
}
